export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Success Screen Viewed',
  object_name: 'MOCSuccessScreenViewed',
  screen: 'MOCSuccess',
  screen_name: 'MOCSuccess',
  object: 'Screen',
  action: 'Viewed',
}

export const AppStoreButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  object_name: 'registrationSuccessAppStore',
  screen: 'registrationSuccess',
  screen_name: 'registrationSuccess',
  cta_title: 'App Store',
}

export const GooglePlayButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  object_name: 'registrationSuccessGooglePlay',
  screen: 'registrationSuccess',
  screen_name: 'registrationSuccess',
  cta_title: 'Google Play',
}

export const ButtonTappedEvent = (text: string) => ({
  object_name: 'registrationSuccessLogin',
  screen: 'registrationSuccess',
  screen_name: 'registrationSuccess',
  cta_title: text,
})
